import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getRentalOwner: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/:id`
    },
    updateRentalOwnerPersonalInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rentalOwners/:id/personalInfo`
    },
    updateRentalOwnerContactInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rentalOwners/:id/contactInfo`
    },
    updateRentalOwnerTaxInfo: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalOwners/:id/taxInfo`
    },
    setRentalOwnerStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rentalOwners/:id/status`
    },
    deleteRentalOwner: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/rentalOwners/:id`
    },
    saveRentalOwnerManagementAgreement: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rentalOwners/:id/managementAgreement`
    },
    create: {
        method: 'POST',
        url: `${BASE_PATH_API}/users/rentalOwners`
    },
    findById: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/:id`
    },
    getByPropertyId: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/rentalOwners`,
        isArray: true
    },
    getRentalOwnersToInactivateProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/rentalOwnersWithActiveStatus`,
        isArray: true
    },
    getRentalOwnersToReactivateProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/rentalOwnersWithInActiveStatus`,
        isArray: true
    },
    getRentalOwnerPropertiesList: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/:id/propertiesList`,
        isArray: true
    },
    getRentalOwnerAllProperties: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/:id/properties/all`,
        isArray: true
    },
    getRentalOwnerProperties: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/:id/properties`,
        isArray: true
    },
    getRentalOwnerEsignatureSummaryForCurrentUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/esignature/summary`,
        isArray: true
    },
    getRentalOwnerEsignatureOtherDocumentsForCurrentUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/esignature/otherDocuments`,
        isArray: true
    },
    getAppliancesByPropertyId: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/properties/:propertyId/appliances`,
        isArray: true
    },
    getPMContactPhoneNumber: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/pmContactPhoneNumber`
    },
    lookupRentalOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/lookup/rentalOwners?isActive?onlySetupForAch?payeeUserId`
    },
    getRentalOwnerEpayAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/:id/bankAccounts/withEpay`
    },
    getRentalOwnerContributionEpaySettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/:id/contributionEpaySettings`
    },
    getRentalOwnerEpayAccountsForCurrentUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/bankAccountsWithEpayForCurrentUser`,
        isArray: true
    },
    getRentalOwnerPropertiesWithEpayForCurrentUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/propertiesWithEpayForCurrentUser`
    },
    getRentalOwnerContributionEpaySettingsForCurrentUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/contributionEpaySettingsForCurrentUser`,
        isArray: true
    },
    getRentalOwnerContributionEpaySettingsForCurrentUserV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/users/rentalOwners/contributionEpaySettingsForCurrentUser`
    },
    saveRentalOwnerContributionEpaySettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/rentalOwners/:id/contributionEpaySettings`
    },
    getRentalOwnerAvailableBalance: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/:id/availableBalance`
    },
    getRentalOwnerPropertiesCounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/:id/properties/counts`
    },
    updateRentalOwnerProperties: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rentalOwners/:id/properties`
    },
    isEFTEnabledForOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/isEFTEnabled`
    },
    getRentalOwnersGrid: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners`,
        params: {
            '$count': true
        }
    },
    searchRentalOwnerFinancials: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/financials`,
        isArray: true
    },
    getRentalOwnerLedgerEntries: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwner/ledger`,
        isArray: true
    },
    getRentalOwnersWebsiteAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwner/websiteAccounts`,
        params: {
            '$count': true
        }
    },
    createRentalOwnerWebsiteAccounts: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalOwner/websiteAccounts`
    },
    doesUserHasAccessToRentalOwnerStatement: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwner/accessStatement`
    },
    doesEftEnabledToRentalOwner: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwner/:ownerId/isEFTEnabled`
    },
    isRentalOwnerContributionEpaySettingsEnabled: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/isRentalOwnerContributionEpaySettingsEnabled`
    },
    getPropertiesWithIncompleteOwnership: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/properties/incompleteOwnership`
    },
    getPropertiesWithTotalOwnership: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/:ownerId/properties`
    },
    updateRentalOwnerPercentagesForProperty: {
        url: `${BASE_PATH_API}/users/rentalOwners/property/:id/ownership`,
        method: 'PUT'
    },
    getRentalOwnerPercentagesForProperty: {
        url: `${BASE_PATH_API}/users/rentalOwners/property/:id/ownership`,
        method: 'GET'
    },
    getPropertiesWithIncompleteOwnershipByRentalOwner: {
        url: `${BASE_PATH_API}/users/rentalOwners/:id/properties/incompleteOwnership`,
        method: 'GET'
    },
    getActiveRentalOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/all`
    },
    isUniqueStaffMemberEmail: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/isUniqueStaffMemberEmail`
    },
    getDefaultManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/defaultManagementFeePolicy`
    }
};

export function RentalOwnersApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getRentalOwnersExportUrl = function getRentalOwnersExportUrl(params) {
        return `${BASE_PATH_API}/rentalOwners/export?${$httpParamSerializer(params)}`;
    };

    service.getRentalOwnerPropertiesExportUrl = function getRentalOwnerPropertiesExportUrl(params, rentalOwnerId) {
        return `${BASE_PATH_API}/rentalOwners/${rentalOwnerId}/properties/export?${$httpParamSerializer(params)}`;
    };

    service.printStatement = function printStatement(ownerId, statementType) {
        return `${BASE_PATH_API}/rentalOwner/${ownerId}/statement/download/${statementType}`;
    };

    return service;
}
RentalOwnersApi.$inject = [
    '$httpParamSerializer'
];
